import { Menu, MenuItem } from '@mui/material';
import Rails from '@rails/ujs';
import Axios from 'axios';
import { useEffect, useState } from 'react';
import toastr from 'toastr';
import { taskStateById, taskStatusLabel } from '../Common/functions';
import { ISelectOption, TaskStatusVal } from '../Common/types';
import { AllProgressStatuses } from '../TaskManage/StatusField';

interface InlineTaskStatusProps {
  taskStatuses: TaskStatusVal[];
  taskTypeId: number;
}

const InlineTaskStatus = (props: InlineTaskStatusProps) => {
  const found = props.taskStatuses.find((ts) => ts.id === props.taskTypeId);
  const [status, setStatus] = useState(found?.status);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  useEffect(() => {
    setStatus(found?.status);
  }, [found?.status]);

  if (!found || !found.task_id || found.status === '-') {
    return <>{taskStateById(props.taskStatuses, props.taskTypeId)}</>;
  }

  function handleChange(opt: ISelectOption): void {
    setStatus(opt.value);
    setAnchorEl(null);

    Axios.put(
      `/task_management/${found.task_id}.json`,
      { project_task: { status: opt.value } },
      {
        headers: {
          'X-CSRF-Token': Rails.csrfToken(),
          'Content-Type': 'application/json',
        },
      }
    ).catch((err) => {
      toastr.error('Status NOT updated');
      console.log(err);
    });
  }

  return (
    <>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setAnchorEl(e.currentTarget);
        }}
      >
        {taskStatusLabel(status)}
      </a>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {AllProgressStatuses.map((ps) => (
          <MenuItem key={ps.value} onClick={() => handleChange(ps)}>
            {ps.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default InlineTaskStatus;
